<template>
    <div>
        <a :href="url">{{ display }}</a>
    </div>
</template>

<script>
import { getLabel } from "@/features/schemas/services/labeller";
import { getEndpoint } from "@/features/schemas/services/schemaProvider";

export default {
    types: [
        "file"
    ],
    props: {
        value: {
            type: Number,
            default: () => null,
        },
        options: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        display() {
            let lookup = this.options?.lookup;
            if (!lookup || !this.value) {
                return "";
            }

            let item = lookup[this.value.toString()];
            return getLabel("file", item);
        },
        url() {
            return getEndpoint("file", "download")
                .path
                .replace("{id}", this.value);
        }
    }
};
</script>
